import { usePrecisionGameStore } from "../store/precisionGame.store";
import { usePrecisionGameState } from "./usePrecisionGameState";
import { usePrecisionGameSync } from "./usePrecisionGameSync";
import { usePrecisionGameTimer } from "./usePrecisionGameTimer";
import { usePrecisionGameClick } from "./usePrecisionGameClick";

export const usePrecisionGame = (collection: string) => {
  // Get base state
  const {
    currentUser,
    attemptCount,
    hasWon,
    success,
    setSuccess,
    currentTime,
    setCurrentTime,
    firstClickTime,
    setFirstClickTime,
    values,
  } = usePrecisionGameState(collection);

  // Sync with server state
  const { winners, mentions, refetch } = usePrecisionGameSync(
    collection,
    currentUser,
    attemptCount,
    setSuccess
  );

  // Handle timer
  usePrecisionGameTimer(firstClickTime, setCurrentTime);

  // Handle click logic
  const { handleClick } = usePrecisionGameClick(
    collection,
    attemptCount,
    values,
    firstClickTime,
    setFirstClickTime,
    setCurrentTime,
    setSuccess,
    winners,
    mentions,
    refetch
  );

  return {
    attemptCount,
    success,
    setAttemptCount: (count: number) =>
      usePrecisionGameStore.getState().setAttemptCount(collection, count),
    setSuccess,
    handleClick,
    currentTime,
    setCurrentTime,
    firstClickTime,
  };
};
